<template>
  <LayoutDefault>
    <section class="vacant-place">
      <h1 class="vacant-place__title">Вакантные места для приема (перевода) обучающихся</h1>
      <VacantPlaceTable :data="dataSource"/>
    </section>
  </LayoutDefault>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import LayoutDefault from '@/layout/LayoutDefault'
import VacantPlaceTable from '@/components/blocks/VacantPlaceTable.vue'

export default {
  name: 'VacantPlaceView',
  components: {
    LayoutDefault,
    VacantPlaceTable
  },
  props: {
  },
  setup () {
    const store = useStore()

    const dataSource = computed(() => {
      // данные для отрисовки таблицы
      return store.getters.getNewsDataTable
    })

    return {
      dataSource
    }
  }
}
</script>

<style lang="scss" scoped>
.vacant-place {
  &__title {
    @include information-block-title;
    margin-bottom: 32px;
  }
}
</style>
